/* eslint-disable max-len */
export const langFile = {
  common: {
    close: 'Cerrar',
    day: 'día',
    euro: '€',
    included: 'Incluidos',
    noResults: 'Sin resultados',
    standardError:
      'Lo sentimos ha ocurrido un error inesperado, inténtalo de nuevo más tarde o contacta con atención al cliente.',
    vatIncluded: 'IVA INCLUIDO',
    terminalIn: 'Terminal de Entrada:',
    terminalOut: 'Terminal de Salida:',
    new: 'Nuevo',
  },
  confirmationStep: {
    return: 'Volver',
    psd2Title: 'Activa tu tarjeta para poder usarla',
    psd2Body:
      'Tu banco solicita validar la tarjeta ****{{cardNumber}} para poder usarla cuando salgas. Sólo es necesario hacerlo una vez y podrás utilizarla en todas tus estancias con nosotros.',
    psd2Button: 'Validar tarjeta',

    instagramTitle: 'Siguenos en Instagram',
    instagramBody:
      'Los mejores contenidos sobre aparca&go y todo lo que necesitas saber sobre tu viaje. ¡Además disfruta de ofertas exclusivas para seguidores!',
    instagramButton: 'Seguir @aparcandgo_es',
    checkCarsevices: 'Ver Presupuesto Car Service',
    willSendEmail:
      'Recibirás un email con todas las instrucciones de llegada y de regreso.',
    isFastlane: '¡Tienes el carril rápido activado!',
    addServicesQuestion: '¿Quieres añadir servicios a tu reserva?',
    addServicesText2: 'Aún estás a tiempo.',
    addServicesClick: 'Añadir servicios',
    reservationNumber: 'Número de reserva',
    additionalInfo: 'Información adicional',
    addServices: 'Añadir servicios',
    addServicesBody:
      'Aún estás a tiempo de aprovechar tu viaje y poner a punto tu coche.',
    agencyReservation: 'Puede consultar la reserva en su Área de Agencia.',
    appleWallet: 'Apple Wallet',
    cancelReservation: 'Cancelar Reserva',
    carServiceInstructions: 'Car Service',
    checkReservation: 'Ver Reserva',
    validateChallengeText: 'Puedes agilizar la salida validando tu tarjeta.',
    validateChallengeButton: 'Validar ahora',
    confirmationEmailSended:
      'Te estamos enviando un correo electrónico de confirmación a',
    fastLaneWashWarning:
      '<b>Has reservado un lavado.</b> Entra al parking por taquilla para que nuestro equipo te indique la zona dónde debes aparcar y dejar las llaves de tu vehículo.',
    covidTitle: 'Medidas Covid-19',
    covidBody:
      'Seguimos todas las medidas de seguridad para que viajes con tranquilidad.',
    covidLink: '/es/info-covid-19',
    downloadApp: 'Descarga nuestra App',
    downloadAppText:
      'Gestiona tu reserva rápidamente desde la App de aparca&go',
    downloadReservation: 'Descargar Reserva',
    editReservation: 'Modificar Reserva',
    fastLaneBody:
      'Entra y sal de nuestro parking a través del carril rápido con el código de barras que recibirás horas antes de tu entrada.',
    fastLaneTitle: '¡Aún puedes ir más rápido!',
    fastLaneLink: '/es/servicios/parking/carril-rapido',
    gracePeriodTitle: 'Aviso sobre el precio de tu reserva',
    gracePeriodBody:
      'Recuerda que tienes hasta las {{hours}}h del {{day}} para recoger tu vehículo sin que se produzcan cambios en el precio de tu reserva. ¡Buen viaje! (<a title="+info tarifas" href="https://www.aparcandgo.com/es/aviso-legal">+info tarifas</a>)',
    ifNotRegistered:
      '¿Reservas sin estar registrad@? Te estás perdiendo un montón de días gratis de parking. <b (click)="registerInConfirmation()"><u>Regístrate ahora</u></b> y empieza a acumular euros en aparca&go.',
    ifSporadicWithRegisteredEmail:
      'Con esta reserva puedes acumular {{newPoints}} euros. <br> Vincula tu reserva a tu cuenta de cliente para seguir acumulando euros y aprovechando las ventajas de tu <a href="/c"><u>área on-line.</u></a>',
    linkReservationCTA: 'Vincular reserva',
    ifRegisteredPoints: 'Con esta estancia acumularás {{newPoints}} euros',
    ifRegisteredPointsUser: ' en tu saldo actual de {{userPoints}}.',
    instructions: 'Instrucciones',
    itv: 'ITV',
    maintenance: 'Mantenimiento',
    manageReservation: 'Gestiona tu reserva',
    moreInfo: 'Más información',
    others: 'Otros',
    paymentBody: 'Paga el importe de esta reserva directamente en el Parking.',
    paymentBodyExpress:
      'Puedes pagar en metálico, con tarjeta o mediante la App.',
    paymentTitleExpress:
      'Paga tu estancia en nuestro parking al pasar por taquilla antes de salir.',
    paymentBodyPremium:
      'Puedes pagar con tarjeta de crédito o mediante la App.',
    paymentTitlePremium:
      'Paga tu servicio cuando te entreguemos de nuevo tu vehículo. ',
    paymentTitleUrban:
      'Paga tu estancia en el {{urbanParkingName}} y recoge las llaves de tu vehículo en taquilla antes de salir del parking.',
    paymentTitle:
      'El pago se efectuará en el Parking (Express y Estaciones) o en el momento de recogida en Premium.',
    reviews: 'Revisiones',
    thanks: '¡Gracias por tu reserva!',
    updated: '¡Tu reserva ha sido actualizada!',
    wash: 'Lavados',
    keysNeededReminder:
      'Recuerda que la reserva requiere dejar la llave a nuestro personal.',
    CTAForm2Title: '¡Ahorra tiempo y esfuerzos!',
    CTAForm2Body:
      'Añade servicios a tu reserva y aprovecha la ocasión para poner a punto tu coche: lavado de coche, repostaje de combustible o recarga, inflado de ruedas, cambio de filtros y aceites, pasar la ITV, etc.. o incluso hacer la revisión oficial de tu coche.',
    CTAForm2BodyShort:
      'Añade servicios a tu reserva y aprovecha la ocasión para poner a punto tu coche.',
    CTAForm2Click: 'Añadir servicios',
  },
  errorTailor: {
    email: 'Email inválido',
    maxLength: 'No debes introducir más de {{requiredLength}}',
    minLength: 'Debe contener {{requiredLength}} o más caracteres',
    required: 'Es obligatorio rellenar el campo',
    requiredDni:
      'No es un documento de identificación válido. Asegúrate de que estás añadiendo un número de DNI sin espacios, guiones ni puntos en el caso de que tu razón social sea un nombre y apellidos (Persona Física) - Ej: 11222333X. Asegúrate de que estás añadiendo un NIF de empresa sin espacios, guiones ni puntos en el caso de que tu razón social sea una sociedad (Jurídica) Ej: B11222333.',
    vatErrorFormatVies:
      'Asegúrate de que si estás fuera de España y dentro de la CEE, añadas el VAT number sin espacios, guiones, ni puntos. Ej: PT111222333',
    requiredEmail: 'Te enviaremos aquí tu confirmación',
    requiredPhone: 'Contactaremos contigo en caso de necesidad',
    requiredSignPlate: 'Con qué vehículo vas a aparcar',
    invalidNameDni: 'El NIF introducido es un DNI, ponga nombre y apellidos',
    invalidNameNie: 'El NIF introducido es un NIE, ponga nombre y apellidos',
  },
  homeModule: {
    homeForm: {
      email: 'Email',
      name: 'Nombre',
      needInvoice: 'Necesito factura',
      phone: 'Teléfono',
      signPlate: 'Matrícula',
      surname: 'Apellidos',
      title: 'Datos de la reserva',
      travelForWork: 'Viajo por trabajo',
    },
  },
  notFoundPage: {
    message: 'Not found page',
  },
  navTab: {
    availableServices: 'Servicios disponibles',
    confirmation: 'Confirmación',
    five: '5',
    four: '4',
    howToPark: 'Cómo quieres aparcar',
    one: '1',
    summary: 'Resumen',
    three: '3',
    travelerData: 'Información del viajero',
    two: '2',
    whereAndWhen: 'Dónde y cuándo',
  },
  productsStep: {
    bkgAenaDialog: {
      text1:
        'El descuento de ahorro en comparación con el parking oficial está calculado usando la tarifa estándar sin reserva.',
      text2:
        'Aunque monitorizamos estos precios de manera constante, éstas tarifas pueden cambiar sin previo aviso. Si tienes dudas sobre el precio o descuento que estás viendo, no dudes en <a href="/es/contacto-telefono-email">contactarnos</a>, y te solucionaremos cualquier duda que tengas.',
      title: 'Comparativa de precios',
    },
    bkgProductCard: {
      aena: 'AENA',
      badDatesBody: 'Para disfrutar de este servicio elige otras fechas.',
      badDatesTitle: '¡No disponible para estas fechas!',
      freeCancellation: 'Cancelación gratis',
      minutes: 'min.',
      moreInfo: 'Más info +',
      payTheParking: 'Pagas en el parking',
      saving: 'ahorro',
      select: 'Elegir',
      highDemandMessage: '¡Hay alta demanda para las fechas que buscas!',
      almostOutMessage: '¡Quedan muy pocas plazas para las fechas que buscas!',
      outOfStockMessage: '¡Últimas plazas disponibles!',
      allTypePlacesOutMessage:
        '¡No disponible para estas fechas! <br> <div>Para disfrutar de este servicio elige otras fechas.<div>',
    },
    bkgTripInfoCruiserName: {
      cruiserName: 'Nombre del crucero',
      info: 'Para poder recogerte, por favor indícanos el nombre del crucero',
      others: 'Otros',
    },
    bkgTripInfoDialog: {
      aboutYourTravel: 'Datos de tu viaje',
      continue: 'Continuar',
      alert:
        'Del {{startDay}} de julio al {{endDay}} de septiembre no pueden acceder al parking vehículos de más de 5,5 metros',
    },
    bkgTripInfoExtras: {
      add: 'Añadir +',
      added: '¡Incluido!',
      externalPlace: 'Plaza exterior',
      improvePlace: 'Elige tu tipo de plaza',
      highDemandMessage: '¡Hay alta demanda para las fechas que buscas!',
      almostOutMessage: '¡Quedan muy pocas plazas para las fechas que buscas!',
      outOfStockMessage: 'Agotado',
      busClaim: '¡Podrás aparcar justo al lado de la parada de bus!',
    },
    bkgTripInfoPassengers: {
      passengersIn: 'Pasajeros de ida',
      passengersOut: 'Pasajeros de vuelta',
      passengersTooltip:
        'Necesitamos saber el número de pasajeros para poder planificar el tráfico de pasajeros y darte el mejor servicio. No hay un coste añadido por pasajero extra.',
      passengersTransfer: '¿Cuántos pasajeros hay que trasladar?',
    },
    bkgTripInfoReturnFlight: {
      addReturnFlight:
        'Para poder recogerte, por favor indícanos tu número de vuelo de regreso',
      returnFlight: 'IB1234',
    },
    bkgProductsPage: {
      selectDeliverCar: 'Escoge cómo aparcar',
      highDemandMessage: '¡Hay alta demanda para las fechas que buscas!',
      almostOutMessage: '¡Quedan muy pocas plazas para las fechas que buscas!',
      outOfStockMessage:
        'No hay disponibilidad en el parking para las fechas seleccionadas. Intenta reservar para otra fecha.',
    },
  },
  sharedModule: {
    bkgSummaryVouchers: {
      title: "¡Canjea tus cupones!",
      discount_percent: "{{value}}% de descuento",
      discount_euro: "{{value}}€ de descuento",
      expires_on: "Caduca el  <br>  {{date}}"
    },
    bkgVoucherBanner: {
      title_singular: "¡Tienes 1 cupón disponible!",
      title_plural: "¡Tienes {{count}} cupones disponibles!",
      body: "¡Canjea tus cupones!"
    },
    bkgCookiesAdvice: {
      accept: 'Entendido',
      reject: 'Rechazar',
      textHtml:
        'Esta web utiliza cookies propias y de terceros para realizar labores analíticas y obtener estadísticas del uso de la web realizado por los usuarios. Puedes configurar las cookies establecidas en cualquier momento y obtener más información al respecto en la <a title="terminos y condiciones" href="/es/politica-cookies">Política de cookies</a>.',
    },
    bkgCustomTiresService: {
      added: 'Se ha añadido el servicio correctamente.',
      title: 'Cambio de neumáticos',
      body:
        'Aprovecha que tu coche está aparcado para cambiar los neumáticos. Te mandaremos un presupuesto para que lo aceptes antes de llegar al parking.',
    },

    bkgCustomServices: {
      added: 'Se ha añadido el servicio correctamente.',
      title: '¿No encuentras el servicio que necesitas?',
      body1: 'No pasa nada, te ayudamos de todas maneras.',
      body2:
        'Ponte en contacto con nosotros y te proporcionaremos una solucióna medida.',
      notes: 'Solicita los servicios que necesites',
      terms:
        'Al rellenar el presente formulario, aceptando las condiciones de servicio, se procederá a registrar tu consulta. Te informamos que, aparca&go S.L. como responsable del fichero, tratará los datos con la única finalidad de gestionar la consulta.',
    },
    bkgHeader: {
      account: 'Tu cuenta',
      greeting: 'Hola',
      login: 'Accede',
      logout: 'Cerrar sesión',
      reservation: 'Tus reservas',
      businessMode: 'Cambiar a perfil Empresa',
      individualMode: 'Cambiar a perfil Particular',
      signUp: 'Regístrate',
    },
    bkgFeedbackDialog: {
      profileTitle: 'Perfil añadido correctamente',
      profileBody: 'Ya puedes usar el perfil de facturación {{profile}}',
      registerTitle: 'Registro Correcto',
      registerBody:
        'Te hemos enviado un email a {{email}} para que puedas confirmar tu email',
      servicesTitle: 'Servicio añadido correctamente',
      servicesBody:
        'Puedes continuar añadiendo servicios a tu reserva, o clicar en el botón Continuar para finalizar tu reserva',
      customServicesTitle: '¡Servicio a medida añadido!',
      customTiresServiceTitle: '¡Servicio de cambio de neumáticos añadido!',
      customServicesBody:
        'Finaliza tu reserva y nos pondremos en contacto contigo para informarte de la disponibilidad y coste del servicio que nos has pedido.',
      vehicleTitle: 'Vehículo añadido',
      vehicleTitleEdit: 'Vehículo editado',
      vehicleBody:
        'Hemos añadido el vehículo {{plate}} - {{model}} a tu perfil correctamente',
      vehicleDangerTitle: 'Vehiculo no encontrado',
      vehicleDangerBody: 'Por favor, selecciona la marca y modelo manualmente',
    },
    bkgFooter: {
      privacyLink: '/es/politica-privacidad',
      legalLink: '/es/aviso-legal',
      siteMapLink: '/es/mapa-web',
      privacy: 'Privacidad',
      legal: 'Aviso legal',
      siteMap: 'Mapa del sitio',
      copyright: '© 2024 aparca&go S.L. Todos los derechos reservados.',
    },
    bkgHourPicker: {
      titleStart: '¿A qué hora quieres entregar el coche?',
      titleEnd: '¿A qué hora quieres recoger el coche?',
      info:
        '<p>Nuestro minibús lanzadera (reserva Express) te dejará en la puerta de la terminal en 5 minutos, aún así te recomendamos llegar al parking con tiempo suficiente para aparcar con tranquilidad.</p> <p>Si prefieres entregarnos tu coche directamente en la terminal (reserva Premium), selecciona la hora exacta a la que tenías planeado llegar al aeropuerto. ¡Te estaremos esperando!.</p>',
      infoShip:
        '<p>Elige tu hora de entrada: a las 8:00am, 9:15am, 10:30am, 12:30am o 12:30pm. Una vez aparcado tendrás 30 minutos para coger nuestro minibús gratuito que te llevará directamente a parking de la Terminal de Cruceros del Puerto.</p>',
    },
    bkgInfoSectionDialog: {
      addToMyBooking: 'Añadir servicio',
      checkControls: 'Comprobación de {{ controlsLength }} puntos de control',
      removeFromMyBooking: 'Quitar de mi reserva',
      select: 'Seleccionar',
      calculatePrice: 'Calcular precio',
      price: 'Precio',
      vat: 'Iva (21%)',
      totalPrice: 'TOTAL CAR SERVICE',
    },
    bkgAlternativeOfferDialog: {
      title: 'Plazas agotadas para este producto',
      booking: 'Confirmar cambio',
      changesDatesOrProduct: 'Deseo cambiar de fechas',
      infoTooltip: '{{description}}',
      newPrice: 'Nuevo precio: ',
    },
    bkgInitialBookingDataDialog: {
      anotherTerminal: 'Vuelvo a otra terminal',
      bookingBtn: 'Reservar',
      dateAndTime: 'Fecha y hora',
      entrance: 'Entrada',
      exit: 'Salida',
      where: '¿Dónde?',
      parking: 'Parking',
      selectParking: 'Selecciona aparcamiento',
      title: 'Seleccione aparcamiento',
      dates: 'Actualiza la reserva',
      datesBtn: 'Continuar',
      deliverCar: '¿Cómo quieres entregar tu coche?',
      pickup: '¿Dónde necesitas que te traslademos?',
      welcomeTitle: 'Todo lo que necesita tu coche mientras estás de viaje',
      welcomeBody:
        'Reserva tu plaza de parking, añade los servicios de taller que necesites, y aparca de forma rápida, cómoda y segura.',
    },
    bkgLoginDialog: {
      accountMessage: '¿No tienes cuenta en aparca&go?',
      bodyTitle: 'Accede a tu cuenta',
      continueRegistration: 'Continuar sin registrarme',
      email: 'Email',
      facebookBtn: 'Facebook',
      forgetPassword: 'Recuperar contraseña',
      googleBtn: 'Google',
      appleBtn: 'Apple',
      loginBtn: 'Acceder',
      password: 'Contraseña',
      signUpFree: 'Regístrate gratis',
      title: 'Reserva aún más rápido',
      individualCustomer: 'Particulares',
      agencies: 'Agencias',
      agencyTitle: 'Accede a tu cuenta de Agencia',
      alias: 'Usuario',
    },
    bkgRecoveryPassDialog: {
      title: 'Restablecer contraseña',
      body:
        'Ingresa la dirección de correo electrónico asociada con tu cuenta y te enviaremos el enlace para restablecer tu contraseña',
      send: 'Enviar enlace',
      checkMail: 'Revisa tu correo',
      accept: 'entendido',
      mailSended:
        'Te hemos enviado un email a {{ email }} para que puedas reiniciar tu contraseña',
    },
    bkgSignUpDialog: {
      access: 'Accede',
      bodyTitle: 'Regístrate para reserva más rápido y acumular euros.',
      cancel: 'Cancelar',
      promoEmails:
        'Acepto recibir comunicaciones de novedades, promociones y descuentos de aparca&go',
      newsletterEmails: 'Acepto suscribirme a la newsletter',
      continueBtn: 'Continuar sin registrarme',
      createError: '¡Hay un error! Revisa los datos y vuelve a intentarlo',
      email: 'Email',
      haveAccount: '¿Ya tienes una cuenta?',
      name: 'Nombre',
      password: 'Contraseña',
      privacyPolicy:
        'He leído y entiendo la <a href="/es/politica-privacidad">Política de privacidad</a>',
      signUpFree: 'Regístrame gratis',
      signUpWithFb: 'Facebook',
      signUpWithGoogle: 'Google',
      signUpWithApple: 'Apple',
      surname: 'Apellidos',
      title: 'Regístrate gratis',
    },
    bkgSummary: {
      acceptPromos:
        'Acepto recibir comunicaciones de novedades, promociones y descuentos de aparca&go.',
      acceptNewsletter: 'Acepto suscribirme a la newsletter.',
      acceptTerms:
        'Acepto la <a href="/es/politica-privacidad" target="_blank" title="Política de privacidad"><strong>Política de privacidad</strong></a> y las <a href="/es/aviso-legal" title="Condiciones de uso aparca&go" target="_blank"><strong>condiciones de uso</strong></a>',
      book: 'Reservar',
      carInsuranceTerms:
        'Declaro que el vehículo está cubierto por el seguro obligatorio del automóvil y la correspondiente autorización administrativa para circular.',
      carServiceTerms:
        'Autorizo a aparca&go y a sus talleres asociados a circular con mi vehículo durante el mínimo tiempo necesario para realizar los servicios contratados.',
      continue: 'Continuar',
      needServices: 'Necesitas seleccionar al menos un servicio para continuar',
      disabledTerms: 'Acepta las condiciones de contratación.',
      disabledBookingForm: 'Revisa los datos de la reserva.',
      disabledBillingForm: 'Revisa los datos de facturación.',
      estimateAccept: '*Al reservar estás aceptando el presupuesto',
      reservationNumber: 'Número de reserva',
      return: 'Volver',
      termsAccepted:
        'Al reservar estás aceptando los <a href="/es/politica-privacidad" target="_blank" title="Política de privacidad"><strong>términos</strong></a> y <a href="/es/aviso-legal" title="Condiciones de uso aparca&go" target="_blank"><strong>condiciones de uso</strong></a> de aparca&go',
    },
    bkgSummaryDiscounts: {
      availablePoints: 'Tus euros acumulados disponibles:',
      discount: 'Descuento:',
      havePromoCode: '¿Tienes un código promocional?',
      insertCode: 'Inserta tu código',
      pointsApplied: '¡{{ points }} euros aplicados correctamente!',
      promoFailed: 'Código no válido',
      promoSuccess: '¡Tu código promocional ha sido aplicado correctamente!',
      redeem: 'Canjear',
      validate: 'Validar',
      wantUsePoints: '¿Quieres utilizar tus euros acumulados?',
    },
    bkgSummaryLocation: {
      location: 'Ubicación del parking',
      premiumLocation: 'Punto de entrega',
      locationDescription: 'Consulta la localización del parking en el mapa.',
      openMap: 'abrir mapa',
      parkingLocation: 'Ubicación del parking',
      howToGet: 'Cómo llegar',
    },
    bkgSummaryPrice: {
      carServiceDiscount: 'Descuento Car Service',
      customService: 'Servicio Personalizado',
      customTiresService: 'Cambio de neumáticos',
      free: 'Gratis',
      freeCancellation: 'Cancela gratis',
      payInParking: 'Paga en el Parking',
      place: 'Plaza',
      doubleSpace: 'Plaza Doble',
      points: 'Euros acumulados',
      price: 'Servicios y precios',
      promo: 'Promo',
      total: 'TOTAL',
      wash: 'Lavado',
      totalWithoutPromo: 'TOTAL SIN PROMO',
      removal: 'Traslado',
      taxesSentence2:
        '(*) Tasas oficiales según tipo emisión de vehículo: 40,60€ gasolina, 45,59€ diesel, 54,98€ furgoneta diesel industrial..)',
      taxesSentence3: '(*) Tasas oficiales según tipo emisión de vehículo',
      carDiscountTitle: 'Descuentos de la promo Car Service',
      carDiscountBody:
        'Has seleccionado servicios por valor de {{total}}€ por lo que te corresponde un {{discount}}% de descuento en el coste de tu Parking.<br><br>Tabla de descuentos en el parking al añadir servicios de Car Service:<br><br>25% en el Parking partir de 99€ en Car Service<br>50% en el Parking partir de 199€ en Car Service<br>75% en el Parking partir de 299€ en Car Service<br>¡Parking Gratis hasta 40€ a partir de 499€ en Car Service!',
      carFerryBody:
        'En reservas con servicios de Car Service de menos de 200€ añadimos el coste del traslado del vehículo hasta el taller. Añade más servicios para eliminar el coste del traslado.',
    },
    bkgSummaryReservation: {
      checkIn: 'Entrada:',
      checkOut: 'Salida:',
      checkInPremium: 'Entrega:',
      checkOutPremium: 'Recogida:',
      diffTimeZone: 'Hora de España',
      data: 'Datos',
      email: 'Email:',
      flightNumber: 'Nº vuelo de vuelta:',
      modify: 'Cambiar',
      name: 'Nombre:',
      plate: 'Matrícula:',
      terminal: 'Terminal:',
      outTerminal: 'Terminal de vuelta:',
      yourReservation: 'Información de la reserva',
      billingProfile: 'Perfil de facturación:',
    },
    bkgSummaryServices: {
      detail: 'Detalles',
      modify: 'Cambiar',
      remove: 'Quitar',
      services: 'Servicios',
    },
    bkgSummaryVehicle: {
      modify: 'Seleccionar otro vehículo',
      edit: 'editar',
      yourVehicle: 'Tu vehículo',
    },
    bkgVehicleDialog: {
      addVehicle: 'Añadir vehículo',
      editVehicle: 'Editar vehículo',
      selectVehicleTitle: 'Seleccionar vehículo',
    },
    bkgVehicleDialogSelectClientCar: {
      addNewVehicle: 'Añade un nuevo vehículo',
      agree: 'Aceptar',
      selectVehicle: 'Seleccionar vehículo',
      selectVehicleSubtitle: 'Elige con qué vehículo vas a llegar',
    },
    bkgVehicleDialogCompleteCarDataForm: {
      agree: 'Aceptar',
      body: 'Carrocería',
      completeVehicleInfo:
        'Necesitamos más datos de tu vehículo para darte el precio exacto de tu servcio',
      kilometers: 'Kilómetros',
      motor: 'Motor',
      selectBody: 'Seleccionar carrocería',
      selectMotor: 'Seleccionar motor',
    },
    bkgVehicleDialogLicensePlate: {
      agree: 'Aceptar',
      forgottenCarLicensePlate: 'No recuerdo la matrícula',
      insertCarLicensePlate: '¿Cual es la matrícula de tu coche?',
      placeholderPlate: '0000 ABC',
    },
    bkgVehicleDialogUmcSelectors: {
      addMakeModelSubtitle: 'Usa marca o modelo del vehículo',
      agree: 'Aceptar',
      make: 'Marca:',
      model: 'Modelo:',
      notFoundCarOption: 'No encuentro mi coche',
      propulsion: 'Propulsión:',
      selectMake: 'Selecciona Marca',
      selectModel: 'Selecciona Modelo',
      selectPropulsion: 'Selecciona Propulsión',
      fromToCurrent: 'a partir del año {{ from }}',
      fromToYear: 'entre el {{ from }} y el {{to}}',
      year: 'Año de fabricación',
    },
    bkgVehicleDialogNotFoundForm: {
      email: 'Email',
      color: 'Color',
      make: 'Marca',
      model: 'Modelo',
      send: 'Enviar',
      text:
        'Indícanos la marca y modelo de tu coche y nos pondremos en contacto contigo para darte el presupuesto.',
    },
    bkgVehicleWarningDialog: {
      title: '¡Atención!',
      text1:
        'Al realizar esta acción se eliminará el vehículo seleccionado y los servicios mecánicos previamente añadidos.',
      text2: '¿Cambiar de vehículo?',
      textModifyKm:
        'Al finalizar esta acción se eliminarán los servicios mecánicos previamente añadidos.',
      textModifyWorkshop:
        'Al finalizar esta acción se eliminarán los servicios mecánicos previamente añadidos.',
      accept: 'Aceptar',
      cancel: 'Cancelar',
    },
    bkgLinkReservationDialog: {
      title: 'Importar reserva',
      loginText: 'Accede para importar reserva',
      linkReservationText:
        'Tu cuenta dispone de múltiples configuraciones. Confirma la que prefieres usar en tu reserva',
      linkReservationTextWithoutConfigurations:
        'Confirma que deseas guardar esta reserva en tu cuenta',
      forgetPassword: 'Recuperar contraseña',
      password: 'Contraseña',
      vehicle: 'Vehículo',
      profile: 'Datos de facturación',
      saveBtn: 'Guardar',
      importBtn: 'Importar',
      login: 'Acceder',
      profileCheckbox: 'No vincular datos de facturación.',
      importVehicle: 'Vincular vehículo actual.',
    },
    bkgChangeUserModeDialog: {
      titleChangeBusiness: '¿Quieres cambiar a tu perfil de empresa?',
      titleChangeParticular: '¿Quieres cambiar a tu perfil particular?',
      bodyChangeBusiness:
        'Estás reservando como usuario particular. Si quieres hacer una reserva de empresa con factura, clica en "cambiar a perfil de empresa".',
      bodyChangeParticular:
        'Estás reservando como usuario de empresa. Si quieres hacer una reserva particular sin factura, clica en "cambiar a perfil particular".',
      btnChangeBusiness: 'Cambiar a perfil de empresa',
      btnChangeParticular: 'Cambiar a perfil particular',
      btnStayAsParticular: 'Seguir reservando como usuario particular',
      btnStayAsBusiness: 'Seguir reservando como usuario de empresa',
    },
  },
  servicesStep: {
    title: 'Aprovecha la ocasión para poner a punto tu coche',
    bkgExtraServices: {
      add: 'Añadir +',
      availableServicesFrom:
        '{{ extrasLength }} programas disponibles desde {{ cheaperServiceUnitaryPrice }}€',
      desinfection: 'Lavados con desinfección',
      remove: 'Quitar -',
      washes: 'Lavados y desinfecciones',
      blockWashes: 'Servicio bloqueado por tu empresa',
    },
    bkgCarServices: {
      add: 'Añadir +',
      calculatePrice: 'Calcular precio',
      freeReservation: '¡Tu reserva te puede salir gratis!',
      notAvailable: 'Actualmente no disponible',
      remove: 'Quitar -',
      detail: 'Ver detalle +',
      workshopText:
        'Elige si quieres contratar un servicio con un taller aparca&go o con un concesionario oficial.',
      agoWorkshop: 'Talleres aparca&go',
      officialWorkshop: 'Concesionario oficial',
      needFees: '+ tasas',
      availabilityHighDemand: 'Pocas plazas disponibles',
      availabilityAlmostOut: 'Casi agotado',
      availabilityOutOfStock: 'Agotado',
    },
    bkgCarServicesB: {
      title: 'Car Service',
      minPriceWarranty: 'Preu mínim garantitzat',
    },
    bkgAdditionalCarServices: {
      title: 'Serveis suplementaris',
    },
  },
  travelerStep: {
    billingForm: {
      addProfile: 'Añadir perfil',
      companyAddress: 'Dirección',
      companyCity: 'Población',
      companyEmail: 'Email de facturación',
      companyName: 'Razón fiscal / Nombre y apellidos',
      companyState: 'Provincia',
      companyVat: 'CIF / NIF',
      companyZip: 'Código postal',
      companyCountry: 'País',
      createProfile: 'Crea un perfil de facturación',
      editProfile: 'Modificar perfil',
      editProfileTitle: 'Modificar perfil de facturación',
      needInvoiceData:
        'Por requerimiento legal todos los servicios de taller requieren factura.',
      newProfileBody:
        'Crea un perfil de facturación para guardar tus datos y no tener que repetirlos cada vez que reservas',
      newProfileTitle: 'Nuevo perfil de facturación',
      profile: 'Perfil',
      title: 'Datos de facturación',
      preventEditCorporateProfile: 'Accede a tu área personal para modificar un perfil corporativo',
    },
    invoiceProfileDialog: {
      accept: 'Aceptar',
      companyAddress: 'Dirección',
      companyCity: 'Población',
      companyEmail: 'Email de facturación',
      companyName: 'Razón fiscal / Nombre y apellidos',
      companyState: 'Provincia',
      companyVat: 'CIF / NIF',
      companyZip: 'Código postal',
      companyCountry: 'País',
      invoicingMethod: 'Método de facturación',
      monthly: 'Mensual',
      saveAsDefaultProfile: 'Guardar como perfil por defecto',
      service: 'Por servicio',
      nifError: 'El NIF introducido es un DNI, ponga nombre y apellidos',
      nieError: 'El NIF introducido es un NIE, ponga nombre y apellidos',
    },
    reservationForm: {
      addVehicle: 'Añadir vehículo',
      editVehicle: 'Editar vehículo',
      email: 'Email',
      name: 'Nombre',
      needInvoice: 'Necesito factura',
      optional: '(Opcional)',
      phone: 'Teléfono',
      record: 'num. Expediente',
      recordCompany: 'Referencia viaje',
      signPlate: 'Matrícula',
      surname: 'Apellidos',
      title: 'Datos de la reserva',
      travelForWork: 'Viajo por trabajo',
      travelForWorkTooltip:
        '¿Viajas por trabajo? Cambia a tu perfil de empresa.',
      paymethod: 'Método de pago',
      paymethodComment: 'No te cobramos ahora, es para acelerar tu salida.',
      vehicle: 'Vehículo',
      notes: 'Comentario sobre tu reserva (Opcional)',
      indicateAtExit: 'Indicarlo a la salida',
      employees: 'Empleados',
      employeesTooltip:
        'Selecciona el trabajador para el que reservas el parking',
      yourData: 'Tus datos',
      modify: 'Modificar',
    },
  },

};
